import { useCallback } from 'react';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
/**
 * Autosave no longer has its own tab, so callers must navigate to AutosaveIntro
 * (no plan set up yet) or AutoSave (plan already exists) instead.
 */
export const useNavigateToAutosave = () => {
    const navigation = useMainStackNavigation();
    const autoSaveId = useAppSelector((state) => state.pots.savingsPlan?.id);
    const navigateToAutosave = useCallback(() => {
        if (autoSaveId) {
            navigation.navigate('AutoSave');
        }
        else {
            navigation.navigate('AutosaveIntro');
        }
    }, [autoSaveId, navigation]);
    return navigateToAutosave;
};
